import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function DocumentCheckIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 30, 30);
  const a11y = resolveA11yProps(props);

  return (
    <svg
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width={width}
      height={height}
      {...rest}
      {...a11y}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M19.5 11V5.3C19.5 3.61984 19.5 2.77976 19.173 2.13803C18.8854 1.57354 18.4265 1.1146 17.862 0.82698C17.2202 0.5 16.3802 0.5 14.7 0.5H5.3C3.61984 0.5 2.77976 0.5 2.13803 0.82698C1.57354 1.1146 1.1146 1.57354 0.82698 2.13803C0.5 2.77976 0.5 3.61984 0.5 5.3V15.7C0.5 17.3802 0.5 18.2202 0.82698 18.862C1.1146 19.4265 1.57354 19.8854 2.13803 20.173C2.77976 20.5 3.61982 20.5 5.29993 20.5H11.5M14 17.5L16 19.5L20.5 15M28.5 19.5V14.3C28.5 12.6198 28.5 11.7798 28.173 11.138C27.8854 10.5735 27.4265 10.1146 26.862 9.82698C26.2202 9.5 25.3802 9.5 23.7 9.5M20.5 29.5H14.3C12.6198 29.5 11.7798 29.5 11.138 29.173C10.5735 28.8854 10.1146 28.4265 9.82698 27.862C9.5 27.2202 9.5 26.3802 9.5 24.7M24.5 23.5L27 26M27 26L29.5 28.5M27 26L29.5 23.5M27 26L24.5 28.5M4.5 5.5H11.138M4.5 9.5H14.3"
        stroke="#D0D0D0"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default DocumentCheckIcon;
